import { Swiper } from "swiper";
import { Navigation, Pagination, EffectCards } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export function initSwiper() {
  const swiper = new Swiper(".business__slider .swiper", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 50,
    loop: true,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      type: "bullets",
    },
  });

  return swiper;
}

export function initTariffsSwiper() {
  const tafiffsSwiper = new Swiper(".tariffsSection", {
    slidesPerView: "auto",
    spaceBetween: 10,
    centeredSlides: true,
    breakpoints: {
      400: {
        centeredSlides: false,
      },
    },
  });

  return tafiffsSwiper;
}
